import React, { useState } from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import {
  QUESTIONS,
  GENERALQUESTIONS,
  PAYMENTQUESTIONS,
  PAGGAGEQUESTIONS,
  SPECIALSERVICES,
  RULES
} from '../constants/index';
import usePageTracking from '../lib/usePageTracking';

const FAQ = () => {
  const [expand, setExpand] = useState(0);
  const [tab, setTab] = useState('kwenda');
  usePageTracking();

  const handleExpand = (index) => {
    setExpand(index);
    if (index === expand) {
      setExpand('');
    }
  };

  let questions;
  switch (tab) {
    case 'kwenda':
      questions = QUESTIONS;
      break;
    case 'general':
      questions = GENERALQUESTIONS;
      break;
    case 'payment':
      questions = PAYMENTQUESTIONS;
      break;
    case 'baggage':
      questions = PAGGAGEQUESTIONS;
      break;
    case 'specialServices':
      questions = SPECIALSERVICES;
      break;
    case 'rules':
      questions = RULES;
      break;
    default:
      questions = QUESTIONS;
  }
  return (
    <div>
      <div className='header-wrapepr'>
        <Header />
      </div>
      <div className='header-image-container faq'>
        <div>
          <h1>هنا تجد الإجابات التي تبحث عنها</h1>
          <p style={{fontSize:'1.5em'}}>ستجد هنا حلولًا سريعة وواضحة لكل تساؤلاتك حول خدماتنا، لضمان تجربة سلسة وخالية من أي تعقيد.
          إذا لم تجد الإجابة التي تبحث عنها، لا تتردد في التواصل معنا مباشرة! نحن دائمًا هنا لمساعدتك.</p>
        </div>
      </div>
      <div className='questions-container'>
        <ul className='questions-tabs'>
          <li onClick={() => { setTab('kwenda'); }} className={tab === 'kwenda' ? 'active-questions-tab' : ''}>أسئلة عن كويندا</li>
          <li onClick={() => { setTab('general'); }} className={tab === 'general' ? 'active-questions-tab' : ''}>معلومات عامة عن التذاكر وشروط السفر</li>
          <li onClick={() => { setTab('payment'); }} className={tab === 'payment' ? 'active-questions-tab' : ''}>الدفع</li>
          <li onClick={() => { setTab('baggage'); }} className={tab === 'baggage' ? 'active-questions-tab' : ''}>الأمتعة</li>
          <li onClick={() => { setTab('specialServices'); }} className={tab === 'specialServices' ? 'active-questions-tab' : ''}>الخدمات الخاصة وكيفية طلبها</li>
          <li onClick={() => { setTab('rules'); }} className={tab === 'rules' ? 'active-questions-tab' : ''}>القوانين</li>
        </ul>
        {
          questions.map((question, key) => {
            return (
              <div key={key}>
                <div className='question'>
                  <div className='question-header' onClick={() => { handleExpand(question.id); }}>
                    <p>{question.body}</p>
                    <i className={expand === question.id ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
                  </div>
                  {
                    expand === question.id &&
                    <>
                      <p>
                        {question.answer}
                      </p>
                      <ul>
                        {
                          question.list && question.list.map((listItem) => {
                            return (
                              <li style={{ marginBottom: '16px' }}>{listItem}</li>
                            );
                          })
                        }
                      </ul>
                    </>
                  }
                </div>
                {
                  question.note &&
                  <div className='faq-notes'>
                    <p>ملاحظة هامة :</p>
                    <p>{question.note}</p>
                  </div>
                }
              </div>
            );
          })
        }
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;